import { render, staticRenderFns } from "./material_list.vue?vue&type=template&id=4fa54dba&scoped=true&"
import script from "./material_list.vue?vue&type=script&lang=js&"
export * from "./material_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa54dba",
  null
  
)

export default component.exports